import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ACPackagedUnitDetail from '../../components/ac_packaged_unit/ACPackagedUnitDetail';
import { defaultRejectHandler, toCoolingCap } from '../../utils/utility';
import {
  getACPackagedUnit,
  editACPackagedUnit,
} from '../../redux/ac_packaged_unit/ac_packaged_unit_actions';

class ACPackagedUnitEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.acDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.ac !== nextProps.ac) && nextProps.show) {
      this.props.getAC(nextProps.ac.id);
    }
  }

  onSaveHandler() {
    const editedAC = this.acDetail.getWrappedInstance().getWrappedInstance().getACData();
    this.props.editAC({
      ...editedAC,
      id: this.props.ac.id,
    });
  }

  render() {
    const { isEditing, errorMessage, acDetail, editAC, getAC, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit a/c packaged unit')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ACPackagedUnitDetail
            ac={acDetail}
            ref={ref => (this.acDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-package-unit-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.packagedUnit.errorMessage,
  isEditing: state.ac.packagedUnit.isEditing,
  acDetail: props.ac && state.ac.packagedUnit.objects[props.ac.id],
});

const mapDispatchToProps = dispatch => ({
  editAC: ac => defaultRejectHandler(
      dispatch(
        editACPackagedUnit(
          ac.id,
          ac.name,
          ac.type,
          ac.brand_id,
          ac.SEER,
          toCoolingCap(ac.cooling_capacity, ac.unit),
          ac.unit,
          ac.power_required,
          ac.description,
          ac.image,
        ),
      ),
    ),
  getAC: id => defaultRejectHandler(dispatch(getACPackagedUnit(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACPackagedUnitEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_packaged_unit/ACPackagedUnitEditModal.js